import useBindActionCreators from 'common/hooks/useBindActionCreators';

import { driverOperations } from '../store';

export const useDriverOperations = (): typeof driverOperations => {
  const bindedActions = useBindActionCreators(driverOperations);
  return bindedActions;
};
